import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function contactPriorityAccounts(state = [], action) {
  switch (action.type) {
    case types.GET_CONTACT_PRIORITY_ACCOUNTS:
      return action.contact_priority_accounts;

    default:
      return state;
  }
}
